<script setup>
import { ref } from 'vue'
import { changeMyPasswordRequest } from '../services/userService.js'

const currentPassword = ref('')
const newPassword = ref('')
const loading = ref(false)
const success = ref('')
const error = ref('')

const parseApiError = (err, fallback) => {
  const detail = err?.response?.data?.detail
  if (typeof detail === 'string' && detail.trim()) return detail
  if (Array.isArray(detail) && detail.length) {
    return detail.map((item) => item?.msg).filter(Boolean).join(', ') || fallback
  }
  return fallback
}

const savePassword = async () => {
  loading.value = true
  success.value = ''
  error.value = ''

  try {
    await changeMyPasswordRequest(currentPassword.value, newPassword.value)
    currentPassword.value = ''
    newPassword.value = ''
    success.value = 'Password changed.'
  } catch (err) {
    error.value = parseApiError(err, 'Failed to change password.')
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <section class="settings-wrap">
    <h1>Security</h1>

    <form class="panel form" @submit.prevent="savePassword">
      <label class="form-label">
        Current password
        <input
          v-model="currentPassword"
          class="form-input"
          type="password"
          autocomplete="current-password"
          required
        />
      </label>

      <label class="form-label">
        New password
        <input
          v-model="newPassword"
          class="form-input"
          type="password"
          autocomplete="new-password"
          required
        />
      </label>

      <button class="btn btn-primary" type="submit" :disabled="loading">
        {{ loading ? 'Saving...' : 'Save' }}
      </button>

      <p v-if="success" class="success">{{ success }}</p>
      <p v-if="error" class="error">{{ error }}</p>
    </form>
  </section>
</template>

<style scoped>
.settings-wrap {
  max-width: 720px;
  margin: 0 auto;
  padding: 2rem;
  display: grid;
  gap: 1rem;
}

.form {
  display: grid;
  gap: 0.75rem;
}

.form-label {
  display: grid;
  gap: 0.35rem;
  color: #111827;
}

.form-input {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.5rem 0.6rem;
}

.success {
  color: #166534;
  background: #dcfce7;
  border-radius: 6px;
  padding: 0.5rem;
}

.error {
  color: #991b1b;
  background: #fee2e2;
  border-radius: 6px;
  padding: 0.5rem;
}
</style>

